import React, { Component } from "react";

// Components
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

class ChairpersonFieldset extends Component {
	constructor(props) {
		super(props);

		this.dataProps = ["chairperson_fname", "chairperson_lname", "chairperson_title"];
		this.miscProps = ["errors", "inProcess"];
	}

	shouldComponentUpdate(nextProps) {
		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const { data, errors, inProcess } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">Chairperson</div>

				<div className="fieldset-indent">
					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Chairperson First Name:</label>

							{!!errors.chairperson_fname && (
								<ErrorWrap animate={1}>{errors.chairperson_fname}</ErrorWrap>
							)}
							<input
								type="text"
								id="chairperson_fname"
								value={data.chairperson_fname}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>

						<div className="form-field half-field">
							<label>Chairperson Last Name:</label>

							{!!errors.chairperson_lname && (
								<ErrorWrap animate={1}>{errors.chairperson_lname}</ErrorWrap>
							)}
							<input
								type="text"
								id="chairperson_lname"
								value={data.chairperson_lname}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
					</div>

					<div className="floated-field-container">
						<div className="form-field half-field">
							<label>Chairperson Title:</label>

							{!!errors.chairperson_title && (
								<ErrorWrap animate={1}>{errors.chairperson_title}</ErrorWrap>
							)}
							<input
								type="text"
								id="chairperson_title"
								value={data.chairperson_title}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={e => this.props.handleInputChange(e)}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default ChairpersonFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/organizations/form-components/ChairpersonFieldset.js